import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";

import StoreLayout from "@/components/StoreLayout";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import Product from "@/pages/Product";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import Account from "@/pages/Account";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Search from "@/pages/Search";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Products from "@/pages/admin/Products";
import Categories from "@/pages/admin/Categories";
import Orders from "@/pages/admin/Orders";
import Customers from "@/pages/admin/Customers";
import Coupons from "@/pages/admin/Coupons";
import Content from "@/pages/admin/Content";
import AdminSettings from "@/pages/admin/Settings";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton theme="light" />
          <Routes>
            <Route path="/" element={<StoreLayout />}>
              <Route index element={<Home />} />
              <Route path="categoria/:slug" element={<Category />} />
              <Route path="produto/:slug" element={<Product />} />
              <Route path="carrinho" element={<Cart />} />
              <Route path="checkout" element={<Checkout />} />
              <Route path="pedido/:id/confirmacao" element={<OrderConfirmation />} />
              <Route path="minha-conta" element={<Account />} />
              <Route path="busca" element={<Search />} />
              <Route path="login" element={<Login />} />
              <Route path="cadastro" element={<Register />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="produtos" element={<Products />} />
              <Route path="categorias" element={<Categories />} />
              <Route path="pedidos" element={<Orders />} />
              <Route path="clientes" element={<Customers />} />
              <Route path="cupons" element={<Coupons />} />
              <Route path="conteudo" element={<Content />} />
              <Route path="configuracoes" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
